import {Component, OnDestroy, OnInit} from '@angular/core';
import {Select, Store} from '@ngxs/store';
import {AppState} from '../../state/appState';
import {Observable, Subscription} from 'rxjs';
import {MerchantModel} from '../../shared/models/merchant.model';
import {FormControl, FormGroup, Validators,} from '@angular/forms';
import {distinctUntilChanged, take} from 'rxjs/operators';
import {RouteEmailMigration, RouteHome, RouteLogin} from '../../state/actions/routing.actions';
import {ActivatedRoute} from '@angular/router';
import {StartLoading, StopLoading} from '../../state/actions/general.actions';
import {SetupService} from '../../shared/services/setup/setup.service';
import {MerchantStatusEnum} from '../../shared/enum/merchantStatusEnum';
import {Login} from '../../state/actions/merchant.actions';
import {CustomValidators} from '../../shared/validators/customValidators';
import {GatewayConfigModel} from '../../shared/services/gateway-config/gatewayConfig.model';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
})
export class RegisterComponent implements OnInit, OnDestroy {
  @Select(AppState.currentMerchant$)
  currentMerchant$: Observable<MerchantModel>;
  @Select(AppState.gatewayConfig$)
  gatewayConfig$: Observable<GatewayConfigModel>;

  private subs: Subscription[] = [];

  public registerForm: FormGroup;

  constructor(
    private store: Store,
    private activatedRoute: ActivatedRoute,
    private setupService: SetupService
  ) {
    this.store.dispatch(new StartLoading());
  }

  ngOnInit(): void {
    this.store.dispatch(new StartLoading());
    this.subs.push(
      this.activatedRoute.params.subscribe((p) => {
        if (p.merchantId) {
          this.initForm(p.merchantId);
          this.store.dispatch(new StopLoading());
        } else {
          this.store.dispatch(new RouteLogin());
        }
      })
    );
    this.subs.push(
      this.currentMerchant$.pipe(distinctUntilChanged()).subscribe((p) => {
        if (p != null) {
          this.store.dispatch(new StartLoading());
          this.store.dispatch(new RouteHome());
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.forEach((s) => s.unsubscribe());
  }

  initForm(merchantId: string): void {
    this.gatewayConfig$.pipe(take(1)).subscribe((cfg) => {
      this.registerForm = new FormGroup(
        {
          merchantId: new FormControl(
            {value: merchantId, disabled: true},
            Validators.required
          ),
          email: new FormControl('', [
            Validators.required,
            Validators.email
          ]),
          newPassword: new FormControl('', [
            Validators.required,
            CustomValidators.passwordSecurity(cfg.merchant.passwordSecurity),
          ]),
          newPasswordRepeat: new FormControl(''),
        },
        [CustomValidators.checkPasswords]
      );

      this.setupService.searchCard(merchantId).subscribe(
        (cardResponse) => {
          switch (cardResponse.status) {
            case MerchantStatusEnum.INIT:
              break;
            case MerchantStatusEnum.EMAIL_MIGRATION:
              return this.store.dispatch(new RouteEmailMigration(merchantId));
            default:
              return this.store.dispatch(new RouteLogin(merchantId));
          }
        },
        (error) => {
          return this.store.dispatch(new RouteLogin(merchantId));
        }
      );
    });
  }

  onSubmit(): void {
    const {merchantId, newPassword, email} = this.registerForm.getRawValue();

    this.setupService.setInitialPinAndEmail(merchantId, newPassword, email).subscribe(
      () => {
        this.store.dispatch(new Login(email, newPassword));
      },
      ({status}) => {
        switch (status) {
          case 409:
            this.registerForm.setErrors({conflict: true});
            break;
          default:
            this.registerForm.setErrors({unknownError: true});
        }
        this.store.dispatch(new StopLoading());
      }
    );
  }

  onResetForm(): void {
    this.store.dispatch(new RouteLogin(''));
  }
}
